import {createSelector} from 'reselect';
import {isLoyaltyExperiment} from './ExperimentSelectors';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings, isLoyaltyExperiment],
  (settings, isExperiment) => !!(settings?.should_show_loyalty_points
    || isExperiment),
);
